import FuTableColumnDropdown from "./FuTableColumnDropdown";

FuTableColumnDropdown.install = function (Vue) {
  Vue.component(FuTableColumnDropdown.name, FuTableColumnDropdown);
};

export default FuTableColumnDropdown;
